import { Ship, Bath, Umbrella, Users, Eye, Camera } from "lucide-react";
import { CARAVELA_IMAGES } from "@/config/constants";
import { memo } from "react";

const caravelaFeatures = [
  { id: "car-estavel", icon: Ship, text: "Embarcação grande e estável" },
  { id: "car-banheiro", icon: Bath, text: "Banheiro a bordo" },
  { id: "car-sombra", icon: Umbrella, text: "Áreas com sombra" },
  { id: "car-espaco", icon: Users, text: "Amplo espaço aberto" },
  { id: "car-vista", icon: Eye, text: "Vista panorâmica" },
  { id: "car-fotos", icon: Camera, text: "Cenário perfeito para fotos" }
];

export const CaravelaSection = memo(({ sectionRef, isVisible }) => {
  return (
    <section 
      id="como-funciona"
      ref={sectionRef}
      className={`pt-6 pb-16 md:pt-8 md:pb-24 bg-gradient-to-b from-gray-100 to-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="experiencia-destaque-section"
    >
      <div className="max-w-6xl mx-auto px-4 text-center">
        {/* Vídeo da Caravela */}
        <div className="max-w-2xl mx-auto mb-8">
          <div className="rounded-3xl overflow-hidden shadow-2xl border-4 border-[#002776]/20 bg-gray-200">
            <video 
              autoPlay 
              loop 
              muted 
              playsInline
              preload="none"
              className="w-full h-auto object-cover"
              onCanPlay={(e) => e.target.play()}
            >
              <source src="https://customer-assets.emergentagent.com/job_4932539a-4a69-41ef-b514-bf7645b306e7/artifacts/4c7n8bsx_lv_0_20260319210744.mp4" type="video/mp4" />
            </video>
          </div>
        </div>

        {/* Título Caravela */}
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl mb-4 leading-tight text-[#002776]">
          UMA CARAVELA SÓ NOSSA
        </h2>
        <p className="text-xl md:text-2xl text-[#009C3B] font-bold mb-6">
          Ninguém mais tem isso na região.
        </p>
        
        <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto mb-8">
          Embarcação grande, estável, com banheiro a bordo, áreas de sombra, espaço aberto, vista panorâmica e cenário perfeito pra foto.
        </p>
        
        {/* [TROCAR: fotos reais da caravela] */}
        
        {/* Grid de Fotos da Caravela */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10">
          {CARAVELA_IMAGES.map((img, i) => (
            <div key={`caravela-img-${i}`} className="rounded-2xl overflow-hidden shadow-2xl aspect-[4/5] group">
              <img src={img} alt={`Caravela ${i+1}`} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
            </div>
          ))}
        </div>
        
        {/* Features */}
        <div className="flex flex-wrap justify-center gap-3">
          {caravelaFeatures.map((feature) => (
            <div key={feature.id} className="flex items-center gap-2 bg-[#002776]/10 rounded-full px-4 py-2 border border-[#002776]/20">
              <feature.icon className="w-4 h-4 text-[#009C3B]" />
              <span className="text-[#002776] text-sm font-medium">{feature.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

export default CaravelaSection;
